import React from "react";
import BlurbImage from "../../../Assets/Images/Football-wave.png";
import "./Blurbs.css";
import { MEDIA_LINKS, COMMON_THUMBNAIL_URL } from "../../../Constants/mediaLinks";

const Blurbs = () => {
    return (
        <>
            <div className="sp-blurbs scp-blurbs">
                <p>
                    Our summer camp and clinics are designed to provide children with a fun, safe, and enriching environment where they can explore new activities, develop skills, and make lasting friendships.
                </p>
                <div className="scp-blurb-container">
                    <div className="scp-blurb-container-item blue">BWC Baseball Summer Camp at Ferryhawks
                        <button className="ec-btn">Register</button>

                    </div>
                    <div className="scp-blurb-container-item yellow">Sports & Rec Summer Camp at I.S. 34

                        <button className="ec-btn">Register</button>
                    </div>
                    <div className="scp-blurb-container-item green">BWC Soccer Summer Camp

                        <button className="ec-btn">Register</button>
                    </div>
                    {/* <div className="scp-blurb-container-item red">Sports & Rec Summer Camp at MSI MCCOWN</div> */}
                </div>
                <div className="variety-header">
                    <h2>Why Choose Us?</h2>
                </div>
                <div className="variety-description">
                    <p>At BWC, we believe in creating experiences that children will remember for a lifetime. Our summer camp and clinics are not just about keeping kids busy; they are about inspiring them to explore their interests, challenge themselves, and grow in a community of peers.</p>
                    <p>Join us for a summer filled with adventure, learning, and fun! For more information and to enroll, contact us at (347) 212-0028.</p>
                </div>
                <hr className="scp-blurbs-hr" />
                
                <div className="video-container" style={{width: "92%", margin: "0 auto"}}>
                    <div style={{position: "relative", width: "100%", paddingBottom: "56.25%"}}>
                        <video
                            controls
                            poster={COMMON_THUMBNAIL_URL}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "12px"
                            }}
                        >
                            <source src={MEDIA_LINKS.SUMMER_CAMP.VIDEO_01} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>

        </>
    );
};
export default Blurbs;
